<template>
    <!-- component -->
    <div class="leading-loose">
        <form @submit.prevent="submit" class="md:w-2/3 mx-auto p-10 bg-white rounded shadow-xl">
            <h2 class="uppercase text-2xl font-bold text-center">{{ __('votre_inscription') }}</h2>
            <div class="mt-4">
                <label class="text-sm block text-cavilam-primary font-semibold">{{ __('Civilite') }} <sup class="text-red-500">*</sup></label>
                <div class="flex flex-row">
                    <label for="madame" class="cursor-pointer inline-flex items-center mx-2">
                        <input v-model="form.civilite" value="madame" type="radio" name="civilite" id="madame" class="cursor-pointer h-5 w-5 text-cavilam-primary border-cavilam-primary" required><span class="ml-2 text-gray-700">{{ __('Madame') }}</span>
                    </label>
                    <label for="monsieur" class="cursor-pointer inline-flex items-center mx-2">
                        <input v-model="form.civilite" value="monsieur" type="radio" name="civilite" id="monsieur" class="cursor-pointer h-5 w-5 text-cavilam-primary border-cavilam-primary" required><span class="ml-2 text-gray-700">{{ __('Monsieur') }}</span>
                    </label>
                    <label for="autre" class="cursor-pointer inline-flex items-center mx-2">
                        <input v-model="form.civilite" value="autre" type="radio" name="civilite" id="autre" class="cursor-pointer h-5 w-5 text-cavilam-primary border-cavilam-primary" required><span class="ml-2 text-gray-700">{{ __('Autre') }}</span>
                    </label>
                </div>
                <p class="text-red-500 text-xs" :class="{'invisible':!form.errors.civilite}">{{ __(form.errors.civilite) }}</p>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2 md:pr-2">
                <input-form libelle="Prenom" name="firstname" :required="true"></input-form>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2">
                <input-form libelle="Nom" name="lastname" :required="true"></input-form>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2 md:pr-2">
                <nationality-selector :liste="nationalites" :required="true"></nationality-selector>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2">
                <label class="text-sm block text-cavilam-primary font-semibold" for="date_naissance">{{ __('date_naissance') }} <sup class="text-red-500">*</sup></label>
                <input v-model="form.date_naissance"
                       @change="checkAdult"
                       placeholder="YYYY-MM-DD"
                       min="1900-01-01"
                       :max="new Date().toISOString().split('T')[0]"
                       :class="{'border-red-500':form.errors.date_naissance}"
                       class="cursor-pointer w-full px-2 py-2 text-gray-700 rounded border-cavilam-primary"
                       id="date_naissance" name="date_naissance" type="date" required
                       pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}">
                <p class="text-red-500 text-xs" :class="{'invisible':!form.errors.date_naissance}">{{ __(form.errors.date_naissance) }}</p>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2 md:pr-2">
                <input-form libelle="Email" name="email" type="email" :readonly="!!(utilisateur && utilisateur.email)" :required="true"></input-form>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2">
                <profession-selector :liste="professions" :required="false"></profession-selector>
            </div>
            <div class="mt-4">
                <input-form libelle="Adresse" name="adresse" :required="true"></input-form>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2 md:pr-2">
                <input-form libelle="Ville" name="ville" :required="true"></input-form>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2">
                <input-form libelle="Code_postal" name="code_postal" :required="true"></input-form>
            </div>
            <div class="mt-4">
                <pays-selector :libelle="'Pays'" :name="'pays'" :liste="pays" :required="true"></pays-selector>
            </div>
            <div class="mt-4">
                <label class="inline-flex items-center mt-3">
                    <input @click="resetFacturation" v-model="form.adresse_facturation_differente" name="adresse_facturation_differente" type="checkbox" class="cursor-pointer h-5 w-5 text-cavilam-primary border-cavilam-primary"><span class="ml-2 text-gray-700">{{ __('cocher_pour_renseigner_une_adresse_de_facturation_differente') }}</span>
                </label>
            </div>
            <div v-if="form.adresse_facturation_differente">
                <div class="mt-4">
                    <input-form libelle="Adresse_facturation" name="adresse_facturation" :required="true"></input-form>
                </div>
                <div class="inline-block mt-2 w-full md:w-1/2 md:pr-2">
                    <input-form libelle="Ville_facturation" name="ville_facturation" :required="true"></input-form>
                </div>
                <div class="inline-block mt-2 w-full md:w-1/2">
                    <input-form libelle="Code_postal_facturation" name="code_postal_facturation" :required="true"></input-form>
                </div>
                <div class="mt-2 mb-4">
                    <pays-selector :libelle="'Pays_facturation'" :name="'pays_facturation'" :liste="pays" :required="true"></pays-selector>
                </div>
            </div>
            <template v-if="contientExamen">
                <div class="inline-block mt-4 w-full md:w-1/2 md:pr-2">
                    <input-form libelle="Ville_naissance" name="ville_naissance" :required="true"></input-form>
                </div>
                <div class="inline-block mt-4 w-full md:w-1/2">
                    <langue-selector :libelle="'langue_maternelle'" :name="'langue_maternelle'" :required="true"></langue-selector>
                </div>
                <div class="mt-4">
                    <pays-selector :libelle="'Pays_naissance'" :name="'pays_naissance'" :liste="pays" :required="true"></pays-selector>
                </div>
            </template>
            <div class="inline-block mt-4 w-full md:w-1/2 md:pr-2">
                <input-form libelle="Mobile" name="mobile" :required="true"></input-form>
            </div>
            <div class="inline-block mt-4 w-full md:w-1/2">
                <input-form libelle="Telephone" name="telephone" :required="(contientExamen)"></input-form>
            </div>
            <div class="mt-4">
                <label class="text-sm block text-cavilam-primary font-semibold">{{ __('etes_vous_deja_venu_au_cavilam') }}</label>
                <div class="flex flex-row">
                    <label class="inline-flex items-center mx-2 cursor-pointer">
                        <input v-model="form.est_deja_client" type="radio" name="est_deja_client" :value="true" id="oui" class="cursor-pointer h-5 w-5 text-cavilam-primary border-cavilam-primary" required><span for="oui" class="ml-2 text-gray-700">Oui</span>
                    </label>
                    <label class="inline-flex items-center mx-2 cursor-pointer">
                        <input v-model="form.est_deja_client" type="radio" name="est_deja_client" :value="false" id="non" class="cursor-pointer h-5 w-5 text-cavilam-primary border-cavilam-primary" required><span for="non" class="ml-2 text-gray-700">Non</span>
                    </label>
                </div>
                <p class="text-red-500 text-xs" :class="{'invisible':!form.errors.est_deja_client}">{{ __(form.errors.est_deja_client) }}</p>
            </div>
            <div v-if="form.est_deja_client" class="inline-block mt-4 w-full md:w-1/2 md:pr-2">
                <input-form libelle="En_quelle_annee" name="annee_venue" :required="true"></input-form>
            </div>
            <div v-if="uploadCV" class="inline-block mt-4 w-full md:w-1/2 md:pr-2">
                <input-file libelle="upload_cv" name="cv" :required="true" :accept="'application/pdf,application/msword,application/rtf,text/rtf,application/vnd.oasis.opendocument.text,application/vnd.openxmlformats-officedocument.wordprocessingml.document'"></input-file>
            </div>
            <div v-if="uploadLM" class="inline-block mt-4 w-full md:w-1/2 md:pr-2">
                <input-file libelle="upload_lm" name="lm" :required="true" :accept="'application/pdf,application/msword,application/rtf,text/rtf,application/vnd.oasis.opendocument.text,application/vnd.openxmlformats-officedocument.wordprocessingml.document'"></input-file>
            </div>
            <template v-if="contientExamen">
                <div class="inline-block mt-4 w-full md:w-1/2 md:pr-2">
                    <input-form libelle="Numero_candidat" name="numero_candidat" :required="false"></input-form>
                </div>
                <div v-if="contientTCF" class="inline-block mt-4 w-full md:w-1/2">
                    <label class="text-sm block text-cavilam-primary font-semibold" for="motif_dinscription">
                        {{ __('motif_dinscription') }} <sup class="text-red-500">*</sup>
                    </label>
                    <select id="motif_dinscription" v-model="form.motif_dinscription"
                            name="motif_dinscription"
                            class="w-full px-2 py-2 text-gray-700 rounded border-cavilam-primary"
                            required>
                        <option :value="null"> -- {{ __('veuillez_selectionner_un_motif_inscription') }} -- </option>
                        <option value="naturalisation">{{ __('naturalisation') }}</option>
                        <option value="renouvellement_carte_de_resident">{{ __('renouvellement_carte_de_resident') }}</option>
                        <option value="renouvellement_permis_de_residence" v-if="$page.props.metas.locale !== 'fr'">{{ __('renouvellement_permis_de_residence') }}</option>
                        <option value="etudes">{{ __('etudes') }}</option>
                        <option value="raison_professionnelles">{{ __('raison_professionnelles') }}</option>
                        <option value="autre">{{ __('autre') }}</option>
                    </select>
                    <p class="text-red-500 text-xs" :class="{'invisible':!form.errors.motif_dinscription}">{{ __(form.errors.motif_dinscription) }}</p>
                </div>
                <div class="mt-4">
                    <p class="text-base block text-cavilam-primary font-semibold">{{ __('piece_jointe_description') }}</p>
                    <div class="flex flex-col lg:flex-row justify-evenly">
                        <div class="mt-4 w-full md:w-64 text-center">
                            <label class="w-64 m-auto flex flex-col items-center px-4 py-6 bg-white text-cavilam-primary rounded-md shadow-sm tracking-wide uppercase border border-cavilam-primary cursor-pointer hover:bg-cavilam-primary hover:text-gray-100">
                                <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                    <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                                </svg>
                                <span class="mt-2 text-base leading-normal">{{ __('piece_jointe_1') }} <sup class="text-red-500">*</sup></span>
                                <input @input="form.pj = $event.target.files[0]" type='file' accept=".jpg, .png, .pdf" name="pj" class="opacity-0" :required="(!utilisateur?.pj)" />
                            </label>
                            <p class="text-red-500 text-xs" :class="{'invisible':!form.errors.pj}">{{ __(form.errors.pj) }}</p>
                            <inertia-link v-if="utilisateur?.pj"
                               as="button"
                               target="_blank"
                               :href="route('utilisateur.download.pj', {'type': 'pj'})"
                               class="relative w-fit h-fit text-sm border-b text-cavilam-primary border-cavilam-primary">
                                Télécharger
                            </inertia-link>
                        </div>
                        <div class="mt-4 w-full md:w-64 text-center">
                            <label class="w-64 m-auto flex flex-col items-center px-4 py-6 bg-white text-cavilam-primary rounded-md shadow-sm tracking-wide uppercase border border-cavilam-primary cursor-pointer hover:bg-cavilam-primary hover:text-gray-100">
                                <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                    <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                                </svg>
                                <span class="mt-2 text-base leading-normal">{{ __('piece_jointe_2') }}</span>
                                <input @input="form.pj_facultative = $event.target.files[0]" type='file' accept=".jpg, .png, .pdf" name="pj_facultative" class="opacity-0" />
                            </label>
                            <p class="text-red-500 text-xs" :class="{'invisible':!form.errors.pj_facultative}">{{ __(form.errors.pj_facultative) }}</p>
                            <inertia-link v-if="utilisateur?.pj"
                               as="button"
                               target="_blank"
                               :href="route('utilisateur.download.pj', {'type': 'pj'})"
                               class="relative w-fit h-fit text-sm border-b text-cavilam-primary border-cavilam-primary">
                                Télécharger
                            </inertia-link>
                        </div>
                    </div>
                </div>
            </template>

            <div v-if="productsCategories.includes('sports-et-francais')">
                <AutorisationParentale></AutorisationParentale>
            </div>
            <div class="mt-2">
                <label for="newsletter" class="inline-flex items-center mt-3">
                    <input v-model="form.newsletter" :class="{'border-red-500':form.errors.newsletter}" name="newsletter" type="checkbox" id="newsletter" class="cursor-pointer h-5 w-5 text-cavilam-primary border-cavilam-primary"><span class="ml-2 text-gray-700">{{ __('acceptation_newsleter') }}</span>
                </label>
                <p class="text-red-500 text-xs" :class="{'invisible':!form.errors.newsletter}">{{ __(form.errors.newsletter) }}</p>
            </div>

            <div class="mt-2">
                <label for="acceptation_traitement_donnees" class="inline-flex items-center mt-3 leading-5">
                    <input v-model="form.acceptation_traitement_donnees" :class="{'border-red-500':form.errors.acceptation_traitement_donnees}" name="acceptation_traitement_donnees" type="checkbox" id="acceptation_traitement_donnees" class="cursor-pointer h-5 w-5 text-cavilam-primary border-cavilam-primary"><span class="ml-2 text-gray-700">{{ __('acceptation_traitement_donnees') }} <sup class="text-red-500">*</sup></span>
                </label>
                <p class="text-red-500 text-xs" :class="{'invisible':!form.errors.acceptation_traitement_donnees}">{{ __(form.errors.acceptation_traitement_donnees) }}</p>
            </div>

            <div>
                <label for="acceptation_cgv" class="inline-flex items-center mt-3">
                    <input v-model="form.acceptation_cgv"  :class="{'border-red-500':form.errors.acceptation_cgv}" name="acceptation_cgv" type="checkbox" id="acceptation_cgv" class="cursor-pointer h-5 w-5 text-cavilam-primary border-cavilam-primary"><span class="ml-2 text-gray-700"><span v-html="__('acceptation_cgv')"></span> <sup class="text-red-500">*</sup></span>
                </label>
                <p class="text-red-500 text-xs" :class="{'invisible':!form.errors.acceptation_cgv}">
                    {{ __(form.errors.acceptation_cgv) }}
                </p>
            </div>
            <template v-for="etape in etapes">
                <img v-if="__(etape.nom + '_img_path') != etape.nom + '_img_path'" :src="__(etape.nom + '_img_path')" class="mt-6">
                <Etape :etape="etape" />
                <div class="text-center" v-if="etape.errors">
                    <span class="font-medium tracking-wide text-red-500 text-xs my-2 font-semibold">
                        {{ __(etape.nom + '_errors') }}
                    </span>
                </div>
            </template>
            <div class="m-4 text-center">
                <breeze-button
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing"
                    id="TM-inscription-submit"
                    >
                    {{ __('envoyer') }}
                </breeze-button>
            </div>
            <div>
                <p class="text-sm text-gray-400 text-right">
                    <sup class="text-red-500">*</sup> {{ __('les_champs_marques_sont_obligatoires') }}
                </p>
            </div>
        </form>
    </div>
</template>

<script>
import App from '@/Layouts/App'
import BreezeButton from '@/Components/Button'
import NationalitySelector from '@/Components/NationalitySelector'
import PaysSelector from "../../Components/PaysSelector";
import ProfessionSelector from "@/Components/ProfessionSelector";
import LangueSelector from "@/Components/LangueSelector";
import InputForm from "@/Components/InputForm";
import InputFile from "@/Components/InputFile";
import AutorisationParentale from "@/Components/forms/AutorisationParentale";
import Etape from "@/Components/forms/Etape";

export default {
    layout: App,
    name: "Donnees",
    components: {
        PaysSelector,
        BreezeButton,
        NationalitySelector,
        ProfessionSelector,
        LangueSelector,
        InputForm,
        InputFile,
        AutorisationParentale,
        Etape,
    },
    props: {
        utilisateur: Object,
        contientExamen: Boolean,
        uploadCV: Boolean,
        uploadLM: Boolean,
        pays: Array,
        nationalites: Array,
        professions: Array,
        contientTCF: Boolean,
        productsCategories: Array,
        etapes: Array,
        panier: Object, // Utilisé pour Google Analytics
    },
    data() {
        if(this.utilisateur && Object.keys(this.utilisateur).length) {
            return {
                form: this.$inertia.form({
                    civilite: this.utilisateur.civilite,
                    firstname: this.utilisateur.prenom,
                    lastname: this.utilisateur.nom,
                    nationalite: this.utilisateur.nationalite,
                    date_naissance: this.utilisateur.date_naissance,
                    email: this.utilisateur.email,
                    profession: this.utilisateur.profession,
                    adresse: this.utilisateur.adresse,
                    ville: this.utilisateur.ville,
                    code_postal: this.utilisateur.code_postal,
                    pays: this.utilisateur.pays,
                    adresse_facturation_differente: !!(this.utilisateur.adresse_facturation),
                    adresse_facturation: this.utilisateur.adresse_facturation,
                    ville_facturation: this.utilisateur.ville_facturation,
                    code_postal_facturation: this.utilisateur.code_postal_facturation,
                    pays_facturation: this.utilisateur.pays_facturation,
                    langue_maternelle: this.utilisateur.langue_maternelle,
                    ville_naissance: this.utilisateur.ville_naissance,
                    pays_naissance: this.utilisateur.pays_naissance,
                    mobile: this.utilisateur.mobile,
                    telephone: this.utilisateur.telephone,
                    est_deja_client: !!(this.utilisateur.est_deja_client),
                    newsletter: !!(this.utilisateur.newsletter),
                    acceptation_cgv: false,
                    acceptation_traitement_donnees: false,
                    annee_venue: this.utilisateur.annee_venue,
                    pj: null,
                    pj_facultative: null,
                    numero_candidat: this.utilisateur.numero_candidat,
                    motif_dinscription: this.utilisateur.motif_dinscription,
                    cv: null,
                    lm: null,
                    autorisation_parentale: {
                        soussignes_parents: null,
                        info_sante_enfant: null,
                        nom_enfant: null,
                        nationalite: null,
                        date_naissance: null,
                        lieu_naissance: null,
                        fait_a: null,
                        fait_le: null,
                        autorisation: null,
                    },
                    autorisation_image: {
                        soussignes_civilite: null,
                        soussignes_nom: null,
                        enfant: null,
                        autorise: null,
                        date: null,
                    },
                    renseignements_enfant_parent: {
                        recommandation_parents: null,
                        regime_alimentaire: null,
                        renseignements_medicaux: null,
                        baignade: null,
                        responsable_nom: null,
                        responsable_tel: null,
                        responsable_tel2: null,
                        responsable_mail: null,
                        responsable_adresse: null,
                        responsable_code_postal: null,
                        responsable_ville: null,
                        responsable_pays: null,
                    },
                    productsCategories: this.productsCategories,
                    etapes: this.etapes,
                    majoriteRequis: null,
                }),
                errors: false,
            }
        } else {
            return {
                form: this.$inertia.form({
                    civilite: null,
                    firstname: null,
                    lastname: null,
                    nationalite: null,
                    date_naissance: null,
                    email: null,
                    profession: null,
                    adresse: null,
                    ville: null,
                    code_postal: null,
                    pays: null,
                    adresse_facturation_differente: false,
                    adresse_facturation: null,
                    ville_facturation: null,
                    code_postal_facturation: null,
                    pays_facturation: null,
                    langue_maternelle: null,
                    ville_naissance: null,
                    pays_naissance: null,
                    mobile: null,
                    telephone: null,
                    est_deja_client: false,
                    newsletter: false,
                    acceptation_cgv: false,
                    acceptation_traitement_donnees: false,
                    annee_venue: null,
                    pj: null,
                    pj_facultative: null,
                    numero_candidat: null,
                    motif_dinscription: null,
                    cv: null,
                    lm: null,
                    autorisation_parentale: {
                        soussignes_parents: null,
                        info_sante_enfant: null,
                        nom_enfant: null,
                        nationalite: null,
                        date_naissance: null,
                        lieu_naissance: null,
                        fait_a: null,
                        fait_le: null,
                        autorisation: null,
                    },
                    autorisation_image: {
                        soussignes_civilite: null,
                        soussignes_nom: null,
                        enfant: null,
                        autorise: null,
                        date: null,
                    },
                    renseignements_enfant_parent: {
                        recommandation_parents: null,
                        regime_alimentaire: null,
                        renseignements_medicaux: null,
                        baignade: null,
                        responsable_nom: null,
                        responsable_tel: null,
                        responsable_tel2: null,
                        responsable_mail: null,
                        responsable_adresse: null,
                        responsable_code_postal: null,
                        responsable_ville: null,
                        responsable_pays: null,
                    },
                    productsCategories: this.productsCategories,
                    etapes: this.etapes,
                    majoriteRequis: null,
                }),
                errors: false,
            }
        }
    },
    methods: {
        checkAdult() {
            if (this.form.majoriteRequis !== null) {
                const frSentence = "Ce programme est disponible à partir de 16 ans. Pour plus d’informations, merci de contacter info@cavilam.com.";
                const enSentence = "This program is available from age 16. For more information, please contact info@cavilam.com.";
                const esSentence = "Este programa está dirigido a estudiantes de 16 años y más. Para preguntas y/o más informaciones, contactarnos : info@cavilam.com.";

                // calc, the minimum date of birth to be 16 years old at the time of the program
                const dateMajoriteRequis = new Date(this.form.majoriteRequis);
                const dateMajorite = new Date(dateMajoriteRequis.getFullYear() - 16, dateMajoriteRequis.getMonth(), dateMajoriteRequis.getDate());
                const dateNaissance = new Date(this.form.date_naissance);
                if (dateNaissance > dateMajorite) {
                    this.form.errors.date_naissance = this.$page.props.metas.locale === 'fr' ? frSentence : this.$page.props.metas.locale === 'en' ? enSentence : esSentence;
                    return false;
                } else {
                    this.form.errors.date_naissance = null;
                    return true;
                }
            }
            return true;
        },
        resetFacturation(e) {
            if(!e.target.checked) {
                this.form.adresse_facturation = '';
                this.form.ville_facturation = '';
                this.form.code_postal_facturation = '';
                this.form.pays_facturation = '';
            }
        },
        submit() {
            if (this.validerEtape() && this.checkAdult()) {
                this.TM_shipping();
                this.form.post(this.route('paiement.recapitulatif'), this.form);
            }
        },
        validerEtape() {
            for (let etape of this.form.etapes) {
                for(let option of etape.options) {
                    if(option.type === 'submit') continue;
                    if((!option.value || !parseInt(option.value)) && option.est_requis) {
                        etape.errors = true;
                        return false;
                    }
                }
                etape.errors = false;
            }
            return true;
        },
        // #region Google Analytics (Tag Manager)
        TM_get_items() {
            let items = [];
            for(let itemId in this.panier) {
                let item = this.panier[itemId];
                let tarif = item.attributes.produit.tarifs.find(tarif => {
                    return tarif.annee == (new Date()).getFullYear();
                });
                if (!tarif) tarif = item.attributes.produit.tarifs[0];

                items.push({
                    item_id: item.attributes.produit.id,
                    item_name: this.__(item.attributes.produit.slug),
                    item_category: this.__(item.attributes.type.slug),
                    item_list_id: item.attributes.categorie.id,
                    item_list_name: this.__(item.attributes.categorie.slug),
                    price: tarif.montant,
                    quantity: item.quantity,
                });
            }
            return items;
        },
        TM_shipping() {
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
                event: "add_shipping_info",
                ecommerce: {
                    currency: "EUR",
                    value: this.montantSousTotal(),
                    items: this.TM_get_items(),
                }
            });
        },
        // #endregion Google Analytics (Tag Manager)
        montantItem(id) {
            let prix = parseFloat(0);
            prix += parseFloat(this.panier[id].price);
            prix += parseFloat(this.montantOptions(id));
            return parseFloat(prix).toFixed(2);
        },
        montantOptions(id) {
            let prix = parseFloat(0);
            for(let etape in this.panier[id].attributes.etapes) {
                let elemEtape = this.panier[id].attributes.etapes[etape];

                // Les frais de transferts seront à régler sur place
                if (elemEtape.nom === 'transfert') continue;

                for(let option in elemEtape.options) {

                    if(!elemEtape.options[option] || !elemEtape.options[option].valeur || typeof elemEtape.options[option].valeur !== 'object' || !elemEtape.options[option].valeur.montant)
                        continue;

                    if(elemEtape.options[option].valeur.type === 'number') {
                        prix += parseFloat(elemEtape.options[option].valeur.montant) * parseFloat(elemEtape.options[option].valeur.value);
                    } else {
                        prix += parseFloat(elemEtape.options[option].valeur.montant);
                    }

                }
            }
            return parseFloat(prix).toFixed(2);
        },
        montantSousTotal() {
            let prix = parseFloat(0);
            for(let itemId in this.panier) {
                prix += parseFloat(this.montantItem(itemId));
            }
            return parseFloat(prix).toFixed(2);
        },

    },
    mounted () {
        this.checkAdult = this.checkAdult.bind(this);
        // check if panier contains a product that requires the user to be aged 16 or more
        this.$nextTick(() => {
            const arrayProduitsAdulte = [1, 3, 4]; // produit_id
            Object.keys(this.panier).forEach((key) => {
                const programmes = this.panier[key].attributes.programmes;
                if(programmes.length > 0) {
                    programmes.map(programme => {
                        if(arrayProduitsAdulte.includes(programme.produit_id)) {
                            if (programme.date_debut !== null) {
                                const dateProgramme = new Date(programme.date_debut);
                                const dateCurrent = this.form.majoriteRequis !== null ? new Date(this.form.majoriteRequis) : new Date('2100-01-01');
                                if (dateProgramme < dateCurrent) {
                                    this.form.majoriteRequis = programme.date_debut;
                                }
                            }
                        }
                    });
                }
            });
        });
    },

}
</script>

<style scoped>

</style>
